import { useRef, useState } from "react";
import { Link } from "react-router-dom";
import { IoPause, IoPlay } from "react-icons/io5";
import "../../Css/homeCategory/HomeCategory.css";
import productreelsCloth from "../../Images/Video/1FIVE Accessories.mp4";

const HomeBagProduct = () => {
    const videoRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(true);

    const handlePlay = async () => {
        try {
            await videoRef.current?.play();
            setIsPlaying(true);
        } catch (error) {
            console.error("Unable to play video:", error);
        }
    };

    const handlePause = () => {
        videoRef.current?.pause();
        setIsPlaying(false);
    };

    return (
        <div className="home-category-product">
            <div className="home-category-page-main-con">
                <div className="row">
                    <div className="col-md-5">
                        <div className="home-category-page-right-con">
                            <div className="home-category-page-right-reels-con">
                                <video
                                    ref={videoRef}
                                    src={productreelsCloth}
                                    autoPlay
                                    muted
                                    loop
                                    playsInline
                                    onPlay={() => setIsPlaying(true)}
                                    onPause={() => setIsPlaying(false)}
                                    style={{ width: "100%", height: "100%", objectFit: "cover", objectPosition: "center center" }}
                                />
                                <div className="home-category-page-video-controls">
                                    {isPlaying ? (
                                        <button
                                            type="button"
                                            onClick={handlePause}
                                            className="home-category-page-video-control-btn"
                                            aria-label="Pause video"
                                        >
                                            <IoPause />
                                        </button>
                                    ) : (
                                        <button
                                            type="button"
                                            onClick={handlePlay}
                                            className="home-category-page-video-control-btn"
                                            aria-label="Play video"
                                        >
                                            <IoPlay />
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-7">
                        <div className="home-category-page-left-con">
                            <div className="home-category-page-left-main-con">
                                {/* <div className="home-category-page-left-image-con-top">
                                    <div className="home-category-page-left-image-con">
                                        <img
                                            src={productImageCloth}
                                            alt="Bag collection preview"
                                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                        />
                                    </div>
                                </div>
                                <h2>Accessories</h2>
                                <h3>Carry the everyday, elevated.</h3> */}
                                {/* <div className="home-category-page-left-main-bottom-con">
                                    <Link to="/accessories" className="home-category-page-left-main-bottom-link">
                                        DISCOVER
                                    </Link>
                                </div> */}
                                {/* <h2>THE PHILOSOPHY</h2> */}
                                <h3>1FIVE <span>Accessories</span></h3>
                                <h4>The difference between good and exceptional lies in the details. Our accessories are thoughtfully crafted to bring sophistication, functionality, and lasting quality to your everyday life.Every detail matters. From premium materials to timeless design, 1FIVE Accessories are created to elevate the everyday with understated elegance.</h4>
                                <Link to="/accessories" className="home-category-page-left-main-bottom-link">
                                    DISCOVER MORE
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeBagProduct;